import React from "react";

const About = () => {
  return <div>Cooks' Kitchen</div>;
};

export default About;

